import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useResizeDetector } from 'react-resize-detector';
import classNames from 'classnames';
import { Button } from 'ziphy-web-shared/basic/lib/buttons';
import styles from './TabsBarDesktop.module.scss';
const TabsBarDesktop = ({ mode, modeSelected, items, value, onChange, onOpenModal, selectAll, moreButtonText = 'btn.more', className, }) => {
    const { t } = useTranslation();
    const { ref, width = 0 } = useResizeDetector({
        handleHeight: false,
        refreshMode: 'debounce',
        refreshRate: 50,
    });
    function getButtonWith(className) {
        var _a;
        const el = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.querySelector('.' + className);
        return el ? el.getBoundingClientRect().width : 0;
    }
    const [visibleItems, setVisibleItems] = useState([]);
    useEffect(() => {
        if (!ref.current)
            return;
        let result = [];
        const containerWidth = ref.current.getBoundingClientRect().width;
        const btnAllWidth = getButtonWith('select-button-all');
        const btnMoreWidth = getButtonWith('select-button-more');
        let availableWidth = containerWidth - btnAllWidth - btnMoreWidth;
        items.forEach((x) => {
            const btnWidth = getButtonWith(`select-button-id-${x.id}`) + 10; // 10px margin between buttons
            if (availableWidth - btnWidth > 0) {
                availableWidth -= btnWidth;
                result.push(x.id);
            }
        });
        setVisibleItems(result);
    }, [width, value, items]);
    const defaultMoreText = t(moreButtonText);
    const moreBtnText = useMemo(() => {
        if (value && items.length && !visibleItems.includes(value)) {
            return items.find((x) => x.id === value).text;
        }
        else {
            return defaultMoreText;
        }
    }, [value, items, visibleItems, defaultMoreText]);
    return (_jsxs("div", Object.assign({ ref: ref, className: classNames(styles.wrapper, className) }, { children: [selectAll && (_jsx("div", Object.assign({ className: classNames(styles.selectAll, 'select-button-all') }, { children: _jsx(Button, Object.assign({ mode: value ? mode : modeSelected, className: classNames(styles.btn, styles.btnVisible), onClick: () => onChange(null) }, { children: selectAll })) }))), items.map((x, index) => (_jsx(Button, Object.assign({ mode: value === x.id ? modeSelected : mode, className: classNames(styles.btn, visibleItems.includes(x.id) && styles.btnVisible, `select-button-id-${x.id}`), onClick: () => onChange(x.id) }, { children: x.text }), index))), onOpenModal && (_jsx(Button, Object.assign({ mode: moreBtnText !== defaultMoreText ? modeSelected : mode, className: classNames(styles.btn, styles.btnMore, items.length && items.length > visibleItems.length && styles.btnVisible, 'select-button-more'), rightElement: 'down', onClick: onOpenModal }, { children: moreBtnText })))] })));
};
export default TabsBarDesktop;
